//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  methods: {
    timeToMinutes(duration) {
      var minutes = Math.floor(duration / 60);
      var seconds = duration % 60 < 10 ? "0" + (duration % 60) : duration % 60;
      return `${minutes}:${seconds}`;
    },
    isSelected(idx) {
      if (this.$route.params.lessonid != idx) return false;
      return true;
    },
  },
  computed: {
    lessonCount() {
      if (this.lessons) {
        return this.lessons.length;
      }
      return 0;
    },
    totalDuration() {
      if (this.lessons) {
        var total = 0;
        this.lessons.forEach((element) => {
          total += parseInt(element.duration);
        });
        return Math.floor(total / 60);
      }
      return 0;
    },
  },
  props: {
    lessons: {
      default: null,
    },
  },
};
